import React, { useEffect, useState } from "react";
import {
    Link,
    Grid,
    Button,
    Card,
    CardContent,
    TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { GLOSSARY_DATA } from "../../common/utility/jsonData";

const style = {
    position: "absolute",
    top: "5%",
    left: "5%",
    height: "95%",
    width: "90%",
    bgcolor: "background.paper",
    p: 2,
    overflow: "scroll",
};

const GlossaryContainer = () => {
    const [selectedLetter, setSelectedLetter] = useState(GLOSSARY_DATA[0].key);

    const alphabets = GLOSSARY_DATA.map((item) => item.key);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);

    useEffect(() => {
        document.title = "Glossary";
        var link = !document.querySelector("link[rel='canonical']")
            ? document.querySelector("link[rel='canonical']")
            : document.createElement("link");
        link.setAttribute("rel", "canonical");
        link.setAttribute(
            "href",
            document.location.protocol +
                "//" +
                document.location.host +
                document.location.pathname,
        );
        document.head.appendChild(link);
    }, []);

    const handleLetterClick = (letter) => {
        setSelectedLetter(letter);
    };

    // const filteredData = selectedLetter
    //   ? GLOSSARY_DATA.find(item => item.key === selectedLetter)?.data || []
    //   : [];

    const filteredData = searchQuery
        ? searchResults
        : GLOSSARY_DATA.find((item) => item.key === selectedLetter)?.data || [];

    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);

        if (query.trim() === "") {
            setSearchResults([]);
            // setSelectedLetter(GLOSSARY_DATA[0].key);
            return;
        }

        const results = [];

        GLOSSARY_DATA.forEach(({ data }) => {
            data.forEach((item) => {
                const titleMatch = item.title
                    .toLowerCase()
                    .includes(query.toLowerCase());
                const shortMatch = item.shortDesc
                    .toLowerCase()
                    .includes(query.toLowerCase());
                const longMatch = item.longDesc
                    .toLowerCase()
                    .includes(query.toLowerCase());

                if (titleMatch) results.push({ ...item, priority: 1 });
                else if (shortMatch) results.push({ ...item, priority: 2 });
                else if (longMatch) results.push({ ...item, priority: 3 });
            });
        });

        results.sort((a, b) => a.priority - b.priority);
        setSearchResults(results);
    };

    return (
        <Box sx={style} align="justify">
            <Box
                mb={4}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Typography variant="h4" gutterBottom>
                    Glossary of some common terms and short forms we use
                </Typography>

                <Box display="flex" gap={1} flexWrap="wrap" sx={{ mt: 1 }}>
                    {alphabets.map((letter) => (
                        <Button
                            key={letter}
                            variant={
                                selectedLetter === letter
                                    ? "contained"
                                    : "outlined"
                            }
                            onClick={() => handleLetterClick(letter)}
                            sx={{
                                color:
                                    letter == selectedLetter
                                        ? "white"
                                        : "white",
                                borderRadius: "50%",
                                minWidth: 40,
                                width: 40,
                                height: 40,
                                padding: 0,
                                // borderColor: 'white',
                                backgroundColor:
                                    letter == selectedLetter
                                        ? "#3f51b5"
                                        : "transparent",
                                opacity: 1,
                                "&:hover": {
                                    backgroundColor:
                                        letter != selectedLetter
                                            ? "rgba(255,255,255,0.1)"
                                            : undefined,
                                },
                            }}
                        >
                            {letter}
                        </Button>
                    ))}
                </Box>
                <Box width="100%" maxWidth="600px" mb={1} mt={2}>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        placeholder="Search glossary..."
                        value={searchQuery}
                        onChange={handleSearch}
                        InputProps={{
                            endAdornment: searchQuery && (
                                <Button
                                    onClick={() => {
                                        setSearchQuery("");
                                        setSearchResults([]);
                                        // setSelectedLetter(GLOSSARY_DATA[0].key);
                                    }}
                                    size="small"
                                    color="secondary"
                                >
                                    Clear
                                </Button>
                            ),
                        }}
                    />
                </Box>
            </Box>
            {filteredData.map((entry) => (
                <Card variant="outlined">
                    <CardContent>
                        <Typography variant="h6">{entry.title}</Typography>
                        <Typography>{entry.shortDesc}</Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ mt: 0.5 }}
                        >
                            {entry.longDesc}
                        </Typography>
                    </CardContent>
                </Card>
            ))}
            {filteredData.length === 0 && selectedLetter && (
                <Typography variant="body1" sx={{ mt: 2 }}>
                    No terms found for "{selectedLetter}"
                </Typography>
            )}
        </Box>
    );
};

export default GlossaryContainer;
